import { func } from 'prop-types';
import httpClient from './httpClient';

/**
 * Login to Job Fair Portal
 *
 * @param {Object} data - Fetch parameters
 * @returns {Promise}
 */
 async function login(data) {
    return httpClient.default.post('/user/login', data);
  }

  async function register(data) {
    return httpClient.default.post('/user/register', data);
  }
  

 async function postJobDetails(data) {
  return httpClient.jobfair.post('/jobs', data);
}  

 async function updateCompanyDetails(data, companyId) {
  return httpClient.jobfair.put('/companies/'+companyId, data);
}

async function uploadCompanyLogo(data, companyId) {
  return httpClient.logo.post('/uploadCompanyLogo', data);
}

async function getCompanyDetails(companyId) {
  return httpClient.jobfair.get('/companies/'+companyId);
}

async function addNewCompany(company) {
  return httpClient.jobfair.post('/companies',company);
}


async function getFeaturedCompanies(){
  return httpClient.jobfair.get('/companies/getFeaturedCompanies');
}
async function getFeaturedJobs(){
  return httpClient.jobfair.get('/Jobs/getFeaturedJobs');
}
async function getJobsByCompanyId(companyId){
  return httpClient.jobfair.get('jobs/getByCompanyId/'+companyId);
}
async function getJobDetails(jobId) {
  return httpClient.jobfair.get('/jobs/'+jobId);
}
async function getAllJobs(){
  return httpClient.jobfair.get('/jobs');
}

async function getAllCompaines(){
  return httpClient.jobfair.get('/companies');
}

async function getAllUsers(){
  return httpClient.jobfair.get('/user');
}

async function deleteCompay(companyId){
  return httpClient.jobfair.delete('/companies/'+companyId);
}

async function deleteUser(userId){
  return httpClient.jobfair.delete('/user/'+userId);
}

async function checkValidUser(user) {
  return httpClient.jobfair.post('/user/checkValidUser',user);
}

async function validateResetToken(user) {
  return httpClient.jobfair.post('/user/validateResetToken',user);
}

async function resetPassword(user) {
  return httpClient.jobfair.post('/user/resetPassword',user);
}

  const api = {
    login,
    register,
    postJobDetails,
    getCompanyDetails,
    updateCompanyDetails,
    getFeaturedJobs,
    getFeaturedCompanies,
    getAllJobs,
    uploadCompanyLogo,
    getJobDetails,
    getJobsByCompanyId,
    getAllCompaines,
    addNewCompany,
    deleteCompay,
    getAllUsers,
    deleteUser,
    checkValidUser,
    resetPassword,
    validateResetToken
  }

  export default api;